import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25 28H7v-2H5v2a2 2 0 002 2h18a2 2 0 002-2v-2h-2zM26.42 8.43l-5.83-5.84A2 2 0 0019.18 2H7a2 2 0 00-2 2v9h2V4h11v5a2 2 0 002 2h5v2h2V9.84a2 2 0 00-.58-1.41z"/><path d="M16 17.86h-.6v3.28h.6c.75 0 1.29-.31 1.29-1.63-.01-.94-.29-1.65-1.29-1.65zM10.26 17.83h-.67v1.71h.52c.62 0 1-.23 1-.86a.78.78 0 00-.85-.85z"/><path d="M28 13H4a2 2 0 00-2 2v9a2 2 0 002 2h24a2 2 0 002-2v-9a2 2 0 00-2-2zm-17.46 7.52h-.95v1.65H8.31v-5.34h2.25a1.76 1.76 0 011.87 1.85 1.75 1.75 0 01-1.89 1.84zm5.66 1.65h-2.1v-5.34h2.1c1.66 0 2.41 1 2.41 2.65s-.77 2.69-2.41 2.69zm7.73-4.3h-2.26v1.28h2.06v1h-2.06v2h-1.29v-5.32h3.55z"/>';
export var FilePDFSVG = function FilePDFSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FilePDFSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FilePDFSVG);